import React from "react";
import { Routes, Route } from "react-router-dom";
import FanLayout from "./FanLayout";
import HomePage from "./pages/HomePage/HomePage";
import LibraryPage from "./pages/LibraryPage/library";
import InboxPage from "./pages/InboxPage/InboxPage"; // Keeping for reference if needed, but route removed
import ChatPage from "./pages/ChatPage/ChatPage"; // Keeping for reference
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import TransactionsPage from "./pages/ProfilePage/TransactionsPage";
import CreatorProfilePage from "./pages/HomePage/CreatorProfilePage";
// import EditProfilePage from "./pages/ProfilePage/EditProfilePage"; // Deprecated
import NotificationsPage from "./pages/ProfilePage/NotificationsPage";
import SettingsPage from "./pages/ProfilePage/SettingsPage";
import CategoryPage from "./pages/HomePage/CategoryPage";
import CreatorSetupWizard from "./pages/CreatorSetupWizard";
import MessagesPage from "./pages/MessagesPage";
import ProfileEditPageNew from "./pages/ProfileEditPage";
import OrdersPage from "./pages/OrdersPage";
import SearchResultsPage from "./pages/SearchResultsPage";

const FanRoutes = () => {
  return (
    <Routes>
      <Route element={<FanLayout />}>
        <Route index element={<HomePage />} />
        <Route path="become-creator" element={<CreatorSetupWizard />} />
        <Route path="creator/:username" element={<CreatorProfilePage />} />
        <Route path="category/:categoryName" element={<CategoryPage />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/edit" element={<ProfileEditPageNew />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="search" element={<SearchResultsPage />} />
      </Route>
    </Routes>
  );
};

export default FanRoutes;
